import Paper from "@mui/material/Paper/Paper";
import Skeleton from "@mui/material/Skeleton/Skeleton";
import Table from "@mui/material/Table/Table";
import TableBody from "@mui/material/TableBody/TableBody";
import TableCell from "@mui/material/TableCell/TableCell";
import TableContainer from "@mui/material/TableContainer/TableContainer";
import TableHead from "@mui/material/TableHead/TableHead";
import TableRow from "@mui/material/TableRow/TableRow";
import BigNumber from "bignumber.js";
import { useParams } from "react-router-dom";
import { useDaoData } from "../libs/daoService";
import { useWalletData } from "../libs/walletService";

const TextSkeleton = () => (
  <Skeleton variant="text" sx={{ fontSize: "1rem" }} />
);

export const AboutDaoTable = () => {
  const { address } = useParams();

  const { data } = useDaoData();

  return (
    <TableContainer component={Paper} sx={{ my: 2 }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell colSpan={2}>Dao Contract</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell component="th" scope="row">
              Name
            </TableCell>
            <TableCell>
              {data ? data.daoContent.name : <TextSkeleton />}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">
              Address
            </TableCell>
            <TableCell>{address}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell component="th" scope="row">
              Description
            </TableCell>
            <TableCell>
              {data ? data.daoContent.description : <TextSkeleton />}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell component="th" scope="row">
              Symbol
            </TableCell>
            <TableCell>
              {data ? data.daoContent.symbol : <TextSkeleton />}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell component="th" scope="row">
              Quorum
            </TableCell>
            <TableCell>
              {data ? (
                ((data.quorumNominator / data.quorumDenominator) * 100).toFixed(
                  2
                ) + "%"
              ) : (
                <TextSkeleton />
              )}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell component="th" scope="row">
              Total Supply
            </TableCell>
            <TableCell>
              {data ? (
                new BigNumber(data.totalSupply.toString())
                  .div(Math.pow(10, parseInt(data.daoContent.decimals)))
                  .toFixed(2)
              ) : (
                <TextSkeleton />
              )}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">
              Decimals
            </TableCell>
            <TableCell>
              {data ? data.daoContent.decimals : <TextSkeleton />}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const AboutWallet = () => {
  const { data: daoData } = useDaoData();
  const { data: jettonData } = useWalletData();

  return (
    <TableContainer component={Paper} sx={{ my: 2 }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell colSpan={2}>Jetton Wallet Contract</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell component="th" scope="row">
              Owner Address
            </TableCell>
            <TableCell>
              {jettonData ? (
                jettonData.ownerAddress.toString()
              ) : (
                <TextSkeleton />
              )}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell component="th" scope="row">
              Balance
            </TableCell>
            <TableCell>
              {daoData && jettonData ? (
                new BigNumber(jettonData.balance.toString())
                  .div(Math.pow(10, parseInt(daoData.daoContent.decimals)))
                  .toFixed(2) + ` ${daoData.daoContent.symbol}`
              ) : (
                <TextSkeleton />
              )}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell component="th" scope="row">
              Locked Balance
            </TableCell>
            <TableCell>
              {daoData && jettonData ? (
                new BigNumber(jettonData.locked.toString())
                  .div(Math.pow(10, parseInt(daoData.daoContent.decimals)))
                  .toFixed(2) + ` ${daoData.daoContent.symbol}`
              ) : (
                <TextSkeleton />
              )}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell component="th" scope="row">
              Lock Expiration Date
            </TableCell>
            <TableCell>
              {jettonData ? (
                jettonData.lockExpiration === 0 ? (
                  "None"
                ) : (
                  new Date(jettonData.lockExpiration * 1000).toLocaleString()
                )
              ) : (
                <TextSkeleton />
              )}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};
export const About = () => {
  return (
    <>
      <AboutDaoTable />
      <AboutWallet />
    </>
  );
};
